import React, { JSX } from 'react';

export const BiometricFaceContent: React.FC = (): JSX.Element => (
  <div className="flex flex-col justify-center text-center font-dmsans">
    <iframe
      id="myBiometricFaceIframe"
      src="https://biometric.bancadoingresso.com.br/face"
      allow="camera"
      width={'100%'}
      height={'100%'}
      style={{ minHeight: '800px' }}
    />
  </div>
);
